export default __webpack_public_path__ + "static/media/IMG_9919.a35c3cbc.jpg";